/** Reads a DS motion-duration token as milliseconds (#11742 round 5): the
 * token may be authored in ms or s, and the callers feed real timers and
 * MUI transition props, both of which need numbers. One parser so the
 * drawer, the phone viewer and any future overlay can't drift on units.
 */
export function motionTokenMs(token: string, fallback: number): number {
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(token)
    .trim();
  const parsed = parseFloat(raw);
  if (!Number.isFinite(parsed)) return fallback;
  return raw.endsWith("ms") || !raw.endsWith("s") ? parsed : parsed * 1000;
}
